import { submitFormToIam, logError } from 'actions';
import { Auth } from 'utils';
import { forms, ActionTypes as types, APIerrorMessages } from 'constants';
import {
  resetAppErrors,
  updatePostAppError,
} from 'actions/setters/updateAppErrors';

const log = { component: 'updateEmail' };

export default values => dispatch => {
  const userGuid = Auth.getUserGuid();
  const userResource = `/users/${userGuid}/change-email-address`;
  const body = {
    userGuid,
    EmailAddress: values.EmailAddress,
  };

  const onSuccess = () => {
    dispatch({
      type: types.UPDATE_USER,
      payload: body,
    });
    dispatch(resetAppErrors());
  };

  const onError = (error = {}) => {
    if (error !== APIerrorMessages.emailAlreadyInUse) {
      dispatch(logError(types.UPDATE_APP_STATUS_POST_ERROR, { ...log, error }));
    }
    dispatch(updatePostAppError(error));
  };

  return dispatch(
    submitFormToIam(forms.Email, userResource, userGuid, body, {
      clearForm: false,
      onSuccess,
      onError,
    }),
  );
};
